import React from "react";
import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import footer from "../assets/divider-brown.png";
import { Choice } from "../story";

/** Properties expected by the CarouselCard component.
 *@param {Choice} content - A Choice component from which the choice text can be extracted. 
*/
interface CarouselCardProps {
    content: Choice
    scrollId: string
    isDisabled: boolean
}

/** A component that displays the text of a single Choice. Used in combination with the Carousel component. */
export const CarouselCard = (props: CarouselCardProps) => {
    const { content, scrollId, isDisabled } = props;

    return (
        <div className={`carousel-card${isDisabled ? "-disabled" : ""}`}>
            <Grid container
            direction={"column"}
            alignItems="center">
                <Grid item>
                    <Card sx={{ borderRadius: "inherit", maxWidth: "inherit", maxHeight: "inherit", height: "inherit", backgroundColor: "inherit", color: "inherit"}}>
                        <div className="carousel-card-content">
                            <CardContent>
                                <Typography>{content.choiceText}</Typography>
                                <div className="carousel-card-header">
                                    <CardMedia
                                    id={scrollId} 
                                    component="img"
                                    image={footer}
                                    alt="Carousel footer"/>
                                </div>
                            </CardContent>
                        </div>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
}